/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_REGIONAL_MANAGERS, GET_REGIONAL_MANAGERS } from 'src/actions/regionalManagerAction';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const routeReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_REGIONAL_MANAGERS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_REGIONAL_MANAGERS: {
      const { items, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = items;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default:
      return state;
  }
};

export default routeReducer;
